import { Range, Editor, Path } from 'slate';
import { isList } from '../utilities.mjs';
import { findAllNodesSafe } from '../../../../../core/queries/findNode.mjs';

function isListToggleActive(editor, {
  at,
  listType
}) {
  let location = at;
  if (Range.isRange(location)) {
    location = Editor.unhangRange(editor, location);
  }
  if (!location) {
    return false;
  }
  const selectedNodes = findAllNodesSafe(editor, {
    at: location,
    match: (_, path) => Path.isChild(path, [0])
  });
  return selectedNodes.every(([node]) => isList(node) && node.listType === listType);
}

export { isListToggleActive };
